import React from "react"
import { FloatingRates } from "./FloatingRates"

export const AdminFloatingRates: React.FC<{ userId?: number; companyId?: string; bankId?: string }> = ({
  userId,
  companyId,
  bankId
}) => {
  return (
    <>
      <FloatingRates userId={userId} companyId={companyId} bankId={bankId} rateType={"AMOUNT"} />
      <FloatingRates userId={userId} companyId={companyId} bankId={bankId} rateType={"M_VAL"} />
    </>
  )
}
